import { defineChannelContract } from 'shared/channels';
import { DomainMessagesTypes } from 'shared/domain/messages/message';

/** Contract between the app's tabs (no worker) for the signed-in session. */
export const authSessionContract = defineChannelContract<{
  requests: Record<never, never>;
  events: {
    /** A tab signed in again after a redirect: the other tabs restore their session. */
    [DomainMessagesTypes.sessionRestored]: undefined;
  };
}>('authSessionChannel');
